import React from 'react'
import { Box } from '@mui/material'
import { motion } from 'framer-motion'

const HeroParticles = () => {
    return (
        <Box
            component={motion.div}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.2 }}
            sx={{
                position: 'fixed',
                inset: 0,
                overflow: 'hidden',
                pointerEvents: 'none',
                zIndex: 0,
                background:
                    'radial-gradient(circle at top left, rgba(255,255,255,0.18), transparent 60%),' +
                    'radial-gradient(circle at bottom right, rgba(212,175,55,0.15), transparent 60%)',
            }}
        >
            {[...Array(6)].map((_, i) => (
                <Box
                    key={i}
                    component={motion.div}
                    initial={{ y: 40, opacity: 0 }}
                    animate={{ y: -40, opacity: 1 }}
                    transition={{
                        duration: 6 + i,
                        repeat: Infinity,
                        repeatType: 'reverse',
                    }}
                    sx={{
                        position: 'absolute',
                        width: 70 + i * 18,
                        height: 70 + i * 18,
                        borderRadius: '50%',
                        border: '1px solid rgba(255,255,255,0.16)',
                        top: `${10 + i * 10}%`,
                        left: `${5 + i * 12}%`,
                    }}
                />
            ))}
        </Box>
    )
}

export default HeroParticles
